import { PaginatedResponse, Review } from '../types';
import apiService from './api';

export class ReviewService {
  async getAllReviews(
    page: number = 0,
    size: number = 10,
    sort?: string,
    filters?: any
  ): Promise<PaginatedResponse<Review>> {
    return apiService.getPaginated<Review>('/api/reviews/admin/all', page, size, sort, filters);
  }

  async getReviewById(id: number): Promise<Review> {
    return apiService.get<Review>(`/api/reviews/${id}`);
  }

  async deleteReview(id: number): Promise<void> {
    await apiService.delete(`/api/reviews/${id}`);
  }
}

export const reviewService = new ReviewService();
export default reviewService;
